document.addEventListener('DOMContentLoaded', () => {
  const variantPicker = document.querySelector('variant-picker[data-template-product-match="true"]');

  // If the variant picker is not found, return
  if (!variantPicker) return;

  // Get the size select
  const getSizeSelect = () =>
    variantPicker.querySelector('select.variant-option__select[name="options[Size]"]');

  // Get the local storage size
  const localSelectedValue = localStorage.getItem('sticky-sizing-selected-value');

  // Get the URL variant selection
  const url = new URL(window.location.href);

  // Check if the URL has a variant selection
  const hasUrlVariantSelection = url.searchParams.has('variant') || url.searchParams.has('option_values');

  // Delegate on variant-picker so the handler survives morph() re-renders.
  variantPicker.addEventListener('change', (event) => {
    // If the event target is not a select element, return
    if (!(event.target instanceof HTMLSelectElement)) return;

    // If the event target name is not Size, return
    if (event.target.name !== 'options[Size]') return;

    const selectedValue = event.target.value;

    // If the selected value is not a string, return
    if (!selectedValue || typeof selectedValue !== 'string') return;

    // Set the local storage item with the selected value
    localStorage.setItem('sticky-sizing-selected-value', selectedValue);
  });

  const firmnessSelect = variantPicker.querySelector('select.variant-option__select[name="options[Firmness]"]');

  // If the firmness select is found
  if (firmnessSelect instanceof HTMLSelectElement) {
    const firmnessDefault = firmnessSelect.getAttribute('data-default-firmness');

    // If the firmness default is set and there is no URL variant selection, set the firmness select to the default
    if (firmnessDefault && !hasUrlVariantSelection) {
      // Set the value of the firmness select
      firmnessSelect.value = firmnessDefault;

      // Trigger the change event on the firmness select
      firmnessSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // URL variant selections should win over sticky sizing on page load.
  if (localSelectedValue && !hasUrlVariantSelection) {
    const variantSelect = getSizeSelect();

    // If the variant select is not a select element, return
    if (!(variantSelect instanceof HTMLSelectElement)) return;

    const localSelectedOption = variantSelect.querySelector(`option[value="${CSS.escape(localSelectedValue)}"]`);

    // If the local selected option is not found, return
    if (!localSelectedOption) return;


    // Set the value of the variant select
    variantSelect.value = localSelectedValue;

    // Trigger the change event on the variant select
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
});